import { Button, Icon, Text } from '@chakra-ui/react'
import { FaArrowDown, FaArrowUp, FaArrowsUpDown } from 'react-icons/fa6'

import { SortDirection, SortKey, SortState } from '../../utils'

/** Horizontal alignment of a table column's header. */
export enum ColumnAlign {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

/** Maps a column alignment to the header's flex justification. */
const JUSTIFY_BY_ALIGN: Record<ColumnAlign, string> = {
  [ColumnAlign.Left]: 'flex-start',
  [ColumnAlign.Center]: 'center',
  [ColumnAlign.Right]: 'flex-end',
}

const SortableColumnHeader = ({
  label,
  sortKey,
  sort,
  onSort,
  align = ColumnAlign.Left,
  pr,
}: {
  /** Column label (localized). */
  label: string
  /** Column this header controls. */
  sortKey: SortKey
  /** Active sort state of the table. */
  sort: SortState
  /** Called with this column's key when the header is clicked. */
  onSort: (key: SortKey) => void
  /** Horizontal alignment of the header within its column. */
  align?: ColumnAlign
  /** Optional trailing padding, to match the column's cell padding. */
  pr?: string
}) => {
  // Derived state
  const isActive = sort.key === sortKey

  let ArrowIcon = FaArrowsUpDown
  if (isActive) {
    ArrowIcon = sort.direction === SortDirection.Desc ? FaArrowDown : FaArrowUp
  }

  return (
    <Button
      variant="plain"
      h="auto"
      minW="0"
      px="0"
      py="0"
      gap="5px"
      w="100%"
      pr={pr}
      justifyContent={JUSTIFY_BY_ALIGN[align]}
      cursor="pointer"
      focusRing="none"
      userSelect="none"
      onClick={() => onSort(sortKey)}
      fontSize="11px"
      fontWeight="bold"
      letterSpacing="0.06em"
      textTransform="uppercase"
      color="gray.500"
      _hover={{ color: 'gray.700' }}
      data-testid={`sort-${sortKey}`}
    >
      <Text as="span">{label}</Text>
      <Icon as={ArrowIcon} boxSize="12px" color={isActive ? 'primary.600' : 'gray.300'} />
    </Button>
  )
}

export default SortableColumnHeader
